/*
    Consent-Core script for initializing Cookiebot and Matomo Tag Manager (MTM) with the correct container ID based on the environment. The Config is located in consent-config.js so that consent-core can run "stand-alone" in the browser without requiring a WordPress environment. This is useful for subsites that also use the same Cookiebot and MTM configuration, but do not have access to the WordPress environment.
*/

import { snlaCbConfig } from './consent-config';

const consentCfg = window.snlaConsentConfig || snlaCbConfig();
const CBID = consentCfg.cbid || '';
const CULTURE = consentCfg.culture || 'NO';
const CONTAINERID = consentCfg.container_id || '';
const REVOKE_STATE_KEY = 'snla_cookiebot_revoke_state';

const getStoredRevokeState = () => {
    try {
        return window.localStorage.getItem(REVOKE_STATE_KEY) === '1';
    } catch (error) {
        return false;
    }
};

const setStoredRevokeState = isRevoked => {
    try {
        window.localStorage.setItem(REVOKE_STATE_KEY, isRevoked ? '1' : '0');
    } catch (error) {
        // Ignore storage errors (private mode, blocked storage, etc.).
    }
};

/*
    Initializes Cookiebot and Matomo Tag Manager (MTM) with the correct container ID based on the environment.
*/
const initCBAndMTM = () => {
    window.dataLayer = window.dataLayer || [];

    const cbScript = document.createElement('script');
    cbScript.id = 'Cookiebot';
    cbScript.src = 'https://consent.cookiebot.com/uc.js';
    cbScript.setAttribute('data-cbid', CBID);
    cbScript.setAttribute('data-blockingmode', 'auto');
    cbScript.setAttribute('data-culture', CULTURE);
    cbScript.type = 'text/javascript';
    document.head.appendChild(cbScript);

    const mtmScript = document.createElement('script');
    mtmScript.type = 'text/javascript';
    mtmScript.text =
        `
        var _mtm = window._mtm = window._mtm || [];
        _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
        (function() {
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src='https://analytics.norskluftambulanse.no/js/container_` +
        CONTAINERID +
        `.js'; s.parentNode.insertBefore(g,s);
        })();
    `;
    document.head.appendChild(mtmScript);
};

const onCookiebotConsentReady = () => {
    if (!window.Cookiebot?.consent) return;
    const c = window.Cookiebot.consent;
    const isRevoked = !c.statistics && !c.marketing && !c.preferences;
    const wasRevoked = getStoredRevokeState();

    // Log custom consent revoke state to Matomo Tag Manager for tracking purposes.
    if (isRevoked && !wasRevoked) {
        window._mtm = window._mtm || [];
        window._mtm.push({ event: 'cookie_consent_revoke' });
    }

    setStoredRevokeState(isRevoked);
};

const CBonConsentReadyHandler = () => {
    window.addEventListener('CookiebotOnConsentReady', onCookiebotConsentReady);

    // If consent was already resolved before this handler starts, apply immediately.
    onCookiebotConsentReady();
};

initCBAndMTM();
window.addEventListener('load', CBonConsentReadyHandler, { once: true });
